import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import SelectGroup from '../../../components/casino/SelectGroup';
import CusDateTimePicker from '../../../components/material-ui/CusDateTimePicker';
import DatePreset from '../../../components/material-ui/DatePreset';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import CusButton from '../../../components/material-ui/CusButton';
import CusAutocomplete from '../../../components/material-ui/CusAutocomplete';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store';
import { API_MAILING } from '../../../api/mailing';

export default function HisMailingFilter({ onFilterClick }) {
  const { t } = useTranslation();
  const mainGroupId = useAppSelector((state) => state.user.group.main?.groupId);

  const { isMobile } = useBootstrapSize();
  const [managerOptions, setManagerOptions] = useState([{ label: t('All'), value: 'skip' }]);
  const [filter, setFilter] = useState({
    groupId: mainGroupId,
    managerId: managerOptions[0].value,
    dateFrom: null,
    dateTo: null
  });

  const startDate = filter.dateFrom || null;
  const endDate = filter.dateTo || null;

  const gridSize = { xs: 12, sm: 6 };

  useEffect(() => {
    setFilter((prev) => ({ ...prev, groupId: mainGroupId }));
  }, [mainGroupId]);

  useEffect(() => {
    if (!filter.groupId) return;

    API_MAILING.list
      .manager({ groupId: filter.groupId })
      .then((res) => {
        const list = res.data.list || [];
        const options = Object.entries(list).map(([key, value]) => ({
          label: value,
          value: parseInt(key)
        }));
        options.unshift({ label: t('All'), value: 'skip' });

        setManagerOptions(options);
      })
      .catch(console.error);
  }, [filter.groupId]);

  return (
    <Stack>
      <Grid container spacing={1} alignItems={'baseline'} justifyContent={'space-between'}>
        <Grid size={12}>
          <SelectGroup
            title="Group"
            hideTooltip
            selectGroupId={filter.groupId}
            setSelectGroupId={(value) => setFilter({ ...filter, groupId: value })}
          />
        </Grid>
        <Grid size={gridSize} mt={1.5}>
          <CusDateTimePicker
            label="Start Date"
            value={startDate}
            onChange={(val) => setFilter((prev) => ({ ...prev, dateFrom: val }))}
            formatChange="YYYY-MM-DD HH:mm:ss"
            clearable
          />
        </Grid>
        <Grid size={gridSize} mt={1.5}>
          <CusDateTimePicker
            label="End Date"
            value={endDate}
            onChange={(val) => setFilter((prev) => ({ ...prev, dateTo: val }))}
            formatChange="YYYY-MM-DD HH:mm:ss"
            startDateForError={startDate}
            clearable
          />
        </Grid>
        <Grid size={12}>
          <DatePreset
            fontSize={isMobile ? 12 : 14}
            setStartDate={(value) => setFilter((prev) => ({ ...prev, dateFrom: value }))}
            setEndDate={(value) => setFilter((prev) => ({ ...prev, dateTo: value }))}
          />
        </Grid>
        <Grid size={gridSize}>
          <CusAutocomplete
            label={'Manager'}
            value={managerOptions.find((opt) => opt.value === filter.managerId)?.label || null}
            onChange={(_, item) => {
              setFilter((prev) => ({ ...prev, managerId: item?.value || null }));
            }}
            options={managerOptions}
          />
        </Grid>
        <Grid size={gridSize} justifyItems={'end'} alignItems={'end'} mt={'auto'}>
          <CusButton
            ml="auto"
            text="Find"
            variant="contained"
            sx={{ px: 5 }}
            onClick={() => onFilterClick(filter)}
          />
        </Grid>
      </Grid>
    </Stack>
  );
}
